import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyApKubjeaTo2UWBor9AtnLJvfyxPWFEYVU",
  authDomain: "proyecto-bajaj.firebaseapp.com",
  databaseURL: "https://proyecto-bajaj.firebaseio.com",
  projectId: "proyecto-bajaj",
  storageBucket: "proyecto-bajaj.appspot.com",
  messagingSenderId: "96970549369",
  appId: "1:96970549369:web:0f9f35a63e2dd6fa318ca8",
  measurementId: "G-PZN1X2F6XV",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// window.$linkserver = "https://apibajaj.curbe.com.ec/"; 
window.$linkserver = "https://apitecnotrackerdev.curbe.com.ec/"; 
// window.$linkserver = 'http://192.168.180.182:5000/'
document.title = "Administrador Bajaj";

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
